import React from 'react'

import { I18n } from '@front/volcanion'
import { TextField, NumberField, ModelAutocompleteField, ModelMenuSelectorField, MenuSelectorField } from '@front/squirtle'
import { Grid, Box } from '@mui/material'

const Row1 = ({ isPopup, companyserviceLabel, companyserviceConfig, autocompleteQueryMutator, validateCodeLength }) =>
  <Grid container spacing={2}>
    {!!isPopup &&
      <Grid size={1}>
        <NumberField
          name='repeat'
          type='number'
          allowNull
          label={I18n.t('voucher.popup.number')}
          minValue={1}
        />
      </Grid>
    }
    <Grid size={2}>
      <TextField
        name='code'
        label={I18n.t('voucher.code')}
        inputProps={{ maxLength: 10 }}
        normalize={_.toUpper}
        validate={validateCodeLength}
      />
    </Grid>
    <Grid size="grow">
      <ModelAutocompleteField
        name='companyservice'
        label={I18n.t(companyserviceLabel)}
        model_name='companyservice'
        config={companyserviceConfig}
        autocompleteMutator={autocompleteQueryMutator}
        required
        selectFirst={false}
        searchMode='search'
        debounceTime={400}
        renderInputProps={{
          inputProps: { style: { textAlign: 'center' } }
        }}
      />
    </Grid>
    <Grid size="grow">
      <ModelMenuSelectorField
        name='schedule'
        label={I18n.t('date.period')}
        model_name='schedule'
        labelKeys={['name']}
        searchMode='search'
        config={{
          initial_filter: { type: 'voucher' },
          forced_filter: { type: 'voucher' }
        }}
        required
      />
    </Grid>
  </Grid>

const Row2 = ({ getStatusOptionProps }) =>
  <Grid container spacing={2}>
    <Grid size="grow">
      <NumberField
        name='max_user_usage'
        label={I18n.t('voucher.max_user_usage')}
        type='number'
        allowNull
        nullValue={null}
        minValue={1}
      />
    </Grid>
    <Grid size="grow">
      <NumberField
        name='max_global_usage'
        label={I18n.t('voucher.max_global_usage')}
        type='number'
        allowNull
        nullValue={null}
        minValue={0}
      />
    </Grid>
    <Grid size="grow">
      <NumberField
        name='amount'
        label={I18n.t('voucher.amount')}
        type='float'
        minValue={0}
        required
      />
    </Grid>
    <Grid size="grow">
      <MenuSelectorField
        name='active'
        label={I18n.t('status.label', { count: 1 })}
        options={[
          { label: I18n.t('status.active'), value: true },
          { label: I18n.t('status.inactive'), value: false },
        ]}
        getOptionProps={getStatusOptionProps}
        allowNone={false}
      />
    </Grid>
  </Grid>

const VoucherForm = (props) =>
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
    <Row1 {...props} />
    <Row2 {...props} />
  </Box>

export default React.memo(VoucherForm)
